// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"8e708582","64":"819303c2","300":"4d3cce89","344":"5946ebc5","644":"75e02e99","680":"bc5b462f","712":"1af88866","894":"d244c878","952":"ad1d1685"}[chunkId] + ".chunk.js";
};